module.exports = __webpack_public_path__ + "img/img-adocao.0dcf24f4.png";